module.exports = __webpack_public_path__ + "img/taste-solution-banner.f00cbea3.png";